import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  @Input() school: any = {};
  isBrowser: boolean;

  footerData: any = {
    links: [
      {
        icon: '../../assets/images/facebook.png',
        name: 'facebook',
        link: '',
        isData: true,
      },
      {
        icon: '../../assets/images/instagram.png',
        name: 'instagram',
        link: '',
        isData: true,
      },
      {
        icon: '../../assets/images/utube.png',
        name: 'utube',
        link: '',
        isData: false,
      },
      {
        icon: '../../assets/images/utube.png',
        name: 'twitter',
        link: '',
        isData: true,
      },
    ],
  };
  location = {
    latitude: this?.school?.latitude,
    longitude: this?.school?.longitude,
    zoom: this?.school?.zoom,
  };
  mapUrl: SafeResourceUrl;
  constructor(
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private dialog: MatDialog
  ) {
    this.mapUrl = this.getMapSrc(this.location);
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    const offset = 100;
    if (this.isBrowser && element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  downloadBrochure() {
    const brochureUrl = this?.school?.prospectus;
    if (brochureUrl) {
      const a = document.createElement('a');
      a.href = brochureUrl;
      a.target = '_blank';
      a.download = 'Brochure.pdf';
      a.click();
    } else {
      alert('Brochure URL not available. Please try again later.');
    }
  }

  openShareDialog() {
    this.dialog.open(ShareDialogComponent, {
      // width: '500px',
      disableClose: true,
      data: {
        slug: this.school.slug,
        baseUrl: 'https://inforida.com/school/',
      },
    });
  }

  getMapSrc(location): SafeResourceUrl {
    const url = `https://maps.google.com/maps?q=${location.latitude}%2C${location.longitude}&hl=es;z=${location.zoom}&output=embed`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
